import { render, staticRenderFns } from "./taskNewDialog.vue?vue&type=template&id=6d32609e&"
import script from "./taskNewDialog.vue?vue&type=script&lang=js&"
export * from "./taskNewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports